import { TextField } from '@origin-digital/style-guide';
import React from 'react';

import analytics from '../../../../analytics';
import { client } from '../../../../utils/apollo';

import { PostcodeFieldProps } from './PostcodeField.types';
import { PostcodeServiceableQuery } from '../../../../apps/SolarContact/SolarContact.types';

class PostcodeField extends React.Component<PostcodeFieldProps> {
  constructor(props: PostcodeFieldProps) {
    super(props);

    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.getValues = this.getValues.bind(this);
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleAsyncSuccess = this.handleAsyncSuccess.bind(this);
    this.handleAsyncFailure = this.handleAsyncFailure.bind(this);
    this.handleAnalyticsOnClick = this.handleAnalyticsOnClick.bind(this);
  }

  componentDidMount() {
    const { form, field } = this.props;

    if (form.values[field.name] && form.values[field.name].length === 4) {
      this.handleOnBlur(undefined);
    }
  }

  handleOnBlur = async (event: React.ChangeEvent<HTMLInputElement> | undefined) => {
    const { form, field, productType, setAsyncFetching, graphQuery } = this.props;
    const postcodeValue = event ? event.target.value : field.value;

    form.setFieldTouched(field.name, true, true);

    if (postcodeValue && postcodeValue.length === 4) {
      form.setFieldValue('hiddenPostcode', 'true', true);
      setAsyncFetching(true);
      const { data }: any = await client
        .query({
          query: graphQuery,
          variables: this.getValues(postcodeValue, productType)
        })
        .catch(() => {
          this.handleAsyncFailure();
        });
      this.handleAsyncSuccess(data, postcodeValue);
    }
  };

  getValues = (value: string, productType: string): Partial<PostcodeServiceableQuery> => {
    return {
      options: {
        productType: productType,
        address: {
          postcode: value
        }
      }
    };
  };

  handleOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    const { form, field, onFieldChange } = this.props;

    if (event.currentTarget.value === '') {
      form.setFieldValue(field.name, '', false);
      form.setFieldValue('address', '', false);
      onFieldChange(field.name, '');
    }
  };

  handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { form, field, onFieldChange } = this.props;

    onFieldChange(field.name, event.currentTarget.value);
    if (event.currentTarget.value.length === 4) {
      form.setFieldValue(field.name, event.currentTarget.value, true);
    }
  };

  handleAsyncSuccess = (data: any, postcode: string): void => {
    const {
      form,
      field,
      onFieldChange,
      parseGraphResult,
      setDisqualification,
      onGraphError,
      setAsyncFetching
    } = this.props;
    const checkType = data.checkServiceability ? data.checkServiceability : data.checkRepairServiceability;
    const serviceable = parseGraphResult(checkType);

    form.setFieldValue('hiddenPostcode', serviceable.toString(), true);
    setDisqualification(serviceable);
    onGraphError(false);
    setAsyncFetching(false);

    onFieldChange(field.name, postcode);
    form.setFieldValue(field.name, postcode, false);
    form.setFieldValue('address', postcode, false);
  };

  handleAsyncFailure = (): void => {
    const { onGraphError, setAsyncFetching } = this.props;

    setAsyncFetching(false);
    onGraphError(true);
  };

  handleAnalyticsOnClick = (): false | undefined => analytics.firstInteraction();

  render() {
    const { field, label, form, transform, maxLength, spinner, graphError, graphMessage } = this.props;
    const valueExists = form.values[field.name] !== '';
    const errorExists = form.errors['hiddenPostcode'] !== undefined || form.errors[field.name] !== undefined;

    const disqualify = valueExists && errorExists && form.values[field.name].length === 4;
    const touched = errorExists && form.touched[field.name];
    const error = disqualify ? ' ' : form.errors[field.name];
    const errorType = graphError ? graphMessage : error;

    return (
      <TextField
        data-lpignore={true}
        label={label}
        name={field.name}
        value={field.value}
        touched={touched}
        error={errorType}
        spinner={spinner}
        transform={transform}
        maxLength={maxLength}
        showCharacterCount
        onKeyUp={e => this.handleOnKeyUp(e)}
        onChange={e => this.handleOnChange(e)}
        onBlur={e => this.handleOnBlur(e)}
        onClick={this.handleAnalyticsOnClick}
      />
    );
  }
}

export { PostcodeField as default };
